import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsObservableComponent } from './simple-icons-observable.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsObservableComponent ],
    exports:      [ SimpleIconsObservableComponent ],
    bootstrap:    []
})
export class SimpleIconsObservableModule {}
